import { render, staticRenderFns } from "./CreateTestDialog.vue?vue&type=template&id=1dd947bc&scoped=true"
import script from "./CreateTestDialog.vue?vue&type=script&lang=js"
export * from "./CreateTestDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateTestDialog.vue?vue&type=style&index=0&id=1dd947bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd947bc",
  null
  
)

export default component.exports